import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const SetBatchedTaskStatusMutation: GraphQLTaggedNode = graphql`
	mutation SetBatchedTaskStatusMutation(
		$contentId: ID!
		$tasks: [InlineTask]!
		$trigger: PageUpdateTrigger = VIEW_PAGE
	) {
		setBatchedTaskStatus(
			batchedInlineTasksInput: { contentId: $contentId, tasks: $tasks, trigger: $trigger }
		) {
			success
		}
	}
`;
